module.exports = __webpack_public_path__ + "static/media/runway backs.4e9b6170.jpg";